import * as React from "react"
import ZeroActivities from "@modules/build/logs/structured/components/ZeroActivities"
import {
  StructuredLog,
  StructuredLogLevel,
  BuildStatus,
  BuildRunnerType,
} from "@modules/graphql/types"
import { useStructuredLogUpdatedSubscription } from "@modules/build/logs/structured/queries.generated"
import { BuildLogsList } from "gatsby-interface"

/* this clears the Typography.js default styling of `code` block, which we use on .com pages */
const clearTypographyDefaultStyle = {
  "code:before,code:after": {
    content: `none`,
  },
}

export type StructuredLogsTimelineProps = {
  structuredLogs: StructuredLog[]
  refetch: () => void
  logLevel: StructuredLogLevel
  buildStatus: BuildStatus
  runnerType: BuildRunnerType
}

export function StructuredLogsTimeline({
  structuredLogs,
  refetch,
  logLevel,
  buildStatus,
}: StructuredLogsTimelineProps) {
  const onSubscription = React.useCallback(() => refetch(), [refetch])

  if (structuredLogs.length === 0) {
    return <ZeroActivities logLevel={logLevel} buildStatus={buildStatus} />
  }

  return (
    <React.Fragment>
      <BuildLogsList
        logItems={structuredLogs}
        aria-label="Build logs"
        css={clearTypographyDefaultStyle}
      />
      {structuredLogs.map(logItem => (
        <StructuredLogSubscription
          key={logItem.id}
          activityId={logItem.id}
          onSubscriptionData={onSubscription}
        />
      ))}
    </React.Fragment>
  )
}

function StructuredLogSubscription({
  activityId,
  onSubscriptionData,
}: {
  activityId: string
  onSubscriptionData: () => void
}) {
  useStructuredLogUpdatedSubscription({
    variables: {
      activityId,
    },
    onSubscriptionData,
  })

  return null
}
